import { EventServicePluginError } from "../JWeb/types";

import { Stack } from "../JWeb/JWebEnums";

export function hasErrorInEventServicePublisher(
  publisher: any | EventServicePluginError
): publisher is EventServicePluginError {
  if (publisher === undefined) {
    console?.error("Publisher not available.");
    return true;
  }
  if (publisher.errorType === undefined) {
    return false;
  }
  console?.error("Publisher with error: ", publisher);
  return true;
}

export const getStratusStack = (_stack: string): Stack | any => {
  if (["prod", "production", "pro"].includes(_stack)) {
    return Stack.production;
  } else if (["stg", "staging", "stage"].includes(_stack)) {
    return Stack.staging;
  } else if (_stack === "local") {
    return Stack.local;
  } else if (["dev", "pie"].includes(_stack)) {
    return Stack.pie;
  }
};
